/* Session picker — only rendered when the chosen group attends more than one
   session (buildSteps adds the step conditionally). Options are that group's
   sessions, labels formatted server-side (name — day · time). */
import { GROUPS } from '../data';
import { useSurvey } from '../SurveyContext';

export function SessionStep() {
  const surveyFlow = useSurvey();
  const group = GROUPS.find((g) => g.id === surveyFlow.answers.teacherId);
  const sessions = group ? group.sessions : [];
  return (
    <div className="intake-opts">
      {sessions.map((s, i) => (
        <button type="button"
          key={s.id}
          className="intake-opt"
          aria-pressed={surveyFlow.answers.sessionId === s.id}
          onClick={() => surveyFlow.selectSession(s.id)}
        >
          <span className="intake-k">{i + 1}</span>
          <span>{s.label}</span>
        </button>
      ))}
    </div>
  );
}
